import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { MFSubmitButton, MFTextField } from '../../lib/formik';
import { useHistory } from 'react-router-dom';
import * as yup from 'yup';
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import {
  AcknowledgeAmlCheckResponseBody,
  ApplicationProps,
  SalesRmType,
  SubDistributorListType,
  VerifyPanResponseBody,
  newSalesRmType,
} from '../../redux-store/types/api-types';
import { Location } from 'history';
import {
  APPLICATION_TYPE,
  IS_DOB_APPLICABLE_FOR_AMC,
  ONBOARDING_INVESTOR,
  USER_ROLES,
} from '../../utils/constant';
import UseRadioGroup from '../../lib/formik/Radio';
import { getInvestorCategory, getNationalityList } from '../../redux-store/actions';

import {
  mdmsCountriesList,
  mdmsInvestorCategoryType,
  nationaliyType,
} from '../../redux-store/types/mdms';
import { getSalesRMsList } from '../../redux-store/actions/userManagement';
import InvestorAMLFailDialog, {
  AmlPopup,
  AmlPopupValues,
  SuccessDialog,
  MobileNumberField,
  ConfirmationDialog,
  MFSelectVerient,
} from '../commonComponents';
import { RootStateType } from '../../redux-store/reducers';
import { emailRegex, phoneRegExp, stringRegex } from '../../utils/regex';
import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';
import {
  futureAge,
  getCountryCodes,
  isSupportSubDistributor,
  valueIsNone,
} from '../../utils/utilityFunctions';
import { addJointHolder, createNewApplication } from '../../redux-store/actions/application';
import { TextDatePicker } from '../../lib/formik/DatePickerWithTextFeild';
import {
  CreateApplicationRequestBody,
  CreateApplicationResponceBody,
} from '../../redux-store/types/application';
import { getDirectSubDistributors } from '../../redux-store/actions/onBoarding';
import { MultipleSelect } from '../../lib/formik/MultipleSelectField';

interface Values {
  applicationType: string;
  investorCategory: string;
  investorSubCategory: string;
  nationality: string;
  countryNationality: string;
  salesRmId: string | number | null;
  placementAgent: string | null;
  subdistributorId: string | number | null;
}
type IValues = Values & {
  firstName: string;
  lastName: string;
  middleName: string;
  emailId: string;
  countryNameAndCode: string;
  countryCode: string;
  mobile: string;
  taxIdNumber?: string;
  dob?: string;
  // hasPOA: boolean;
};
export default function InitializeInvestor({
  location,
}: {
  location: Location<{
    application: ApplicationProps;
    redirectTo: string;
    firstHolderName: string;
  }>;
}): JSX.Element {
  const [salesRmsList, setSalesRmList] = useState<SalesRmType[]>([]);

  const { redirectTo = '', application, firstHolderName = '' } = location.state || {};
  const { id, salesRmId = '', placementAgent = '', subdistributorId = '' } = application || {};
  const dispatch = useDispatch();
  const history = useHistory();
  const [mdmsCountriesList, setMdmsCountriesList] = useState<mdmsCountriesList[]>([]);
  const [mdmsInvestorType, setMdmsInvestorType] = useState<mdmsInvestorCategoryType>({});
  const [direct, setDirect] = useState<{
    subDistributorType: string;
    subDistributorDetails: SubDistributorListType[];
  }>({ subDistributorType: '', subDistributorDetails: [] });

  const [restrict, setRestrict] = useState<boolean>(false);
  const { role } = useSelector((store: RootStateType) => store.auth);
  const isDistributorLogin = [USER_ROLES.DISTRIBUTOR, USER_ROLES.SUBDISTRIBUTOR].includes(role);

  const validationSchema1 = (subDistributorType?: string) =>
    yup.object().shape({
      applicationType: yup.string().nullable().required('Onboarding Investor Type is required'),
      investorCategory: yup
        .string()
        .nullable()
        .required('Investor Category is required')
        .oneOf(Object?.keys(mdmsInvestorType), 'Invalid value for Investor Category'),
      investorSubCategory: yup
        .string()
        .nullable()
        .test('investorSubCategory', (value, context) => {
          const fieldValue = value === null ? '' : value;
          const { createError, path, parent } = context;
          const mdmsInvestorTypeArray = mdmsInvestorType[
            parent.investorCategory || ''
          ]?.subCategory.map((inv) => inv.key);
          // .filter((env) => env !== 'none');
          if (!fieldValue) {
            return createError({
              message: 'Investor Sub Category is required',
              path,
            });
          }
          if (!mdmsInvestorTypeArray.includes(fieldValue)) {
            return createError({
              message: 'Invalid value for Investor Sub Category',
              path,
            });
          }
          return true;
        }),

      salesRmId: yup
        .string()
        .nullable()
        .test('salesRmId', (value, context) => {
          const { createError, path, parent } = context;
          if (!value && !parent.placementAgent) {
            return createError({
              message: 'Placement Agent is Required',
              path,
            });
          }
          return true;
        }),
      subdistributorId: yup
        .string()
        .nullable()
        .test('subdistributorId', (value, context) => {
          const { createError, path } = context;
          if (!value && isSupportSubDistributor(subDistributorType || '')) {
            return createError({
              message: 'Distributor Sales RM is Required',
              path,
            });
          }
          return true;
        }),
      countryNationality: yup
        .string()
        .nullable()
        .test('countryNationality', (value, context) => {
          const fieldValue = value === null ? '' : value;
          const { createError, path } = context;
          if (!fieldValue) {
            return createError({
              message: 'Nationality is required',
              path,
            });
          }
          if (!mdmsCountriesList?.map((item) => item.nationality).includes(fieldValue)) {
            return createError({
              message: 'Invalid value for Nationality',
              path,
            });
          }
          return true;
        }),
      nationality: yup
        .string()
        .nullable()
        .test('nationality', (value, context) => {
          const fieldValue = value === null ? '' : value;
          const { createError, path } = context;
          if (!fieldValue) {
            return createError({
              message: 'Country of Tax Residency is required',
              path,
            });
          }
          if (!mdmsCountriesList?.map((item) => item.nationality).includes(fieldValue)) {
            return createError({
              message: 'Invalid value for Country of Tax Residency’',
              path,
            });
          }
          return true;
        }),
    });
  const initialValues1: Values = {
    // applicationType: id && redirectTo ? 'individual' : '',
    applicationType: 'individual',
    investorCategory: '',
    investorSubCategory: '',
    countryNationality: '',
    nationality: '',
    salesRmId: salesRmId
      ? salesRmId.toString()
      : placementAgent === 'none' || isDistributorLogin
      ? 'none'
      : null,
    placementAgent: placementAgent || (isDistributorLogin ? 'none' : null) || null,
    subdistributorId: subdistributorId ? subdistributorId.toString() : null,
  };

  useEffect(() => {
    (async function () {
      try {
        if (USER_ROLES.SUBDISTRIBUTOR === role) {
          const directSubDistributors = (await dispatch(
            getDirectSubDistributors()
          )) as unknown as SubDistributorListType;
          setDirect({
            subDistributorType: directSubDistributors.subdistributorType || '',
            subDistributorDetails:
              directSubDistributors?.directSubdistributorsDetails?.directSubdistributors || [],
          });
        }
        const nationalitiesMdmsMasters = (await dispatch(
          getNationalityList()
        )) as unknown as nationaliyType;
        setMdmsCountriesList(nationalitiesMdmsMasters.countries);
        const categoryMasters = (await dispatch(
          getInvestorCategory()
        )) as unknown as mdmsInvestorCategoryType;
        setMdmsInvestorType(categoryMasters);
        const salesRms = (await dispatch(
          getSalesRMsList({ isActive: true })
        )) as unknown as newSalesRmType;
        setSalesRmList(salesRms?.salesrms);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);
  const handleSubmit1 = async (values: Values) => {
    if (values.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) {
      return;
    }
    //need to fetch POA status here due to multiple calls happening when network goes offline in enter mobile/emailid  screen
    // const res = (await dispatch(IsApplicableForPOA())) as unknown as IsApplicableForPOAResponseBody;
    // const { powerOfAttorney } = res;
    history.push('enter-email-id', {
      ...values,
      salesRmId: valueIsNone(values.salesRmId) ? null : values.salesRmId,
      redirectTo,
      firstHolderName,
      application,
      // powerOfAttorney,
    });
  };

  return (
    <>
      <Formik
        initialValues={initialValues1}
        validationSchema={validationSchema1(direct?.subDistributorType)}
        onSubmit={handleSubmit1}>
        {({ handleSubmit, resetForm, values, setValues }) => (
          <>
            <Box component="form" noValidate onSubmit={handleSubmit}>
              <Box sx={{ mt: 1.5 }}>
                <UseRadioGroup
                  formLabel="Select Investor Type"
                  name={`applicationType`}
                  items={Object.keys(ONBOARDING_INVESTOR)
                    .filter((_option) =>
                      id && redirectTo
                        ? ONBOARDING_INVESTOR[_option] !== ONBOARDING_INVESTOR.non_individual
                        : _option
                    )
                    ?.map((option) => ({
                      label: ONBOARDING_INVESTOR[option],
                      value: option,
                    }))}
                  disabled={true}
                />
              </Box>
              <MFSelectVerient
                name={`investorCategory`}
                label={'Investor Category'}
                items={(Object?.keys(mdmsInvestorType) || [])?.map((item) => ({
                  key: mdmsInvestorType[item].displayText,
                  value: item,
                }))}
              />
              <MFSelectVerient
                name={`investorSubCategory`}
                label={'Investor Sub-Category'}
                items={mdmsInvestorType[values.investorCategory || '']?.subCategory?.map(
                  (item) => ({
                    key: item.label,
                    value: item.key,
                  })
                )}
                onChange={({ target: { value } }: any) => {
                  // if (!valueIsNone(value)) {
                  setValues({ ...values, investorSubCategory: value });
                  // } else {
                  //   setRestrict(value);
                  // }
                }}
                disabled={!values.investorCategory}
              />
              <MFSelectVerient
                name={`nationality`}
                label={'Country of Tax Residency'}
                items={mdmsCountriesList?.map((item) => ({
                  key: item.nationality,
                  value: item.nationality,
                }))}
                searchFieldPlaceholder={'Search Nationality'}
                searchSelectEnable={true}
              />
              <MFSelectVerient
                name={`countryNationality`}
                label={'Nationality'}
                items={mdmsCountriesList?.map((item) => ({
                  key: item.nationality,
                  value: item.nationality,
                }))}
                searchFieldPlaceholder={'Search Nationality'}
                searchSelectEnable={true}
              />
              <MFSelectVerient
                name={`salesRmId`}
                label={'Placement Agent'}
                items={[{ key: 'None', value: 'none' }]?.concat(
                  salesRmsList?.map((item) => ({
                    key: item.name,
                    value: item.id.toString(),
                  }))
                )}
                searchSelectEnable={salesRmsList?.length > 10}
                onChange={({ target: { value } }) =>
                  setValues({
                    ...values,
                    placementAgent: valueIsNone(value)
                      ? (value as unknown as string)
                      : salesRmsList.find((salesRm) => Number(salesRm.id) === Number(value))
                          ?.name || null,
                    salesRmId: valueIsNone(value) ? 'none' : (value as unknown as string),
                  })
                }
                disabled={!!id || isDistributorLogin}
                searchFieldPlaceholder={'Search Placement Agent'}
              />
              {isSupportSubDistributor(direct?.subDistributorType) && (
                <MFSelectVerient
                  name={`subdistributorId`}
                  label={'Distributor Sales RM'}
                  items={direct.subDistributorDetails?.map((item) => ({
                    key: item.user.firstName,
                    value: String(item.id),
                  }))}
                  searchSelectEnable={direct.subDistributorDetails?.length > 10}
                  disabled={!!id}
                  searchFieldPlaceholder={'Search Distributor Sales RM'}
                />
              )}
              <ConfirmationDialog
                message="Please select the valid investor sub-category"
                open={restrict}
                setOpen={() => setRestrict(false)}
                onSave={() => {
                  setRestrict(false);
                  setValues({ ...values, investorSubCategory: 'none' });
                }}
                onCancel={() => {
                  setRestrict(false);
                }}
              />
              <MFSubmitButton
                label="Proceed"
                disabled={
                  // valueIsNone(values.investorSubCategory) ||
                  ONBOARDING_INVESTOR[values.applicationType] === ONBOARDING_INVESTOR.non_individual
                }
              />
            </Box>
          </>
        )}
      </Formik>
    </>
  );
}

interface TValues {
  response: VerifyPanResponseBody | AcknowledgeAmlCheckResponseBody;
  taxIdNumber: string;
  dob: string;
}

export function EnterEmailMobileNumber({
  location,
}: {
  location: Location<
    Values & {
      application: ApplicationProps;
      redirectTo: string;
      firstHolderName: string;
      powerOfAttorney: boolean;
    }
  >;
}): JSX.Element {
  const {
    redirectTo = '',
    application,
    firstHolderName = '',
    applicationType = '',
    investorCategory = '',
    investorSubCategory = '',
    nationality = '',
    countryNationality = '',
    salesRmId = null,
    placementAgent,
    powerOfAttorney = false,
    subdistributorId = '',
  } = location.state || {};
  const { id, applicants = [] } = application || {};
  const dispatch = useDispatch();
  const history = useHistory();
  const [openDialog, setOpenDialog] = useState<{ open: boolean; message: string }>({
    open: false,
    message: '',
  });

  const [amlPopup, setAmlPopup] = useState<{
    res: CreateApplicationResponceBody;
  } | null>(null);

  const [amlFailedresponse, setAmlFailedresponse] = useState('');
  const [amlFailedresInvestor, setAmlFailedResInvestor] = useState<boolean>(false);
  const [amlAcknowledgementLoading, setAmlAcknowledgementLoading] = useState(false);
  const [disablePOA, setDisablePOA] = useState(false);

  const applicantMobileNumbers = applicants.map((applicant) => applicant.mobile);
  const { role } = useSelector((store: RootStateType) => store.auth);

  const validationSchema1 = yup.object().shape({
    firstName: yup
      .string()
      .nullable()
      .matches(stringRegex, 'Invalid First Name')
      .required('First Name is required'),
    middleName: yup.string().nullable().matches(stringRegex, 'Invalid Middle Name'),
    lastName: yup
      .string()
      .nullable()
      .matches(stringRegex, 'Invalid Last Name')
      .required('Last Name is required'),
    emailId: yup.string().test('emailId', (value, context) => {
      const { createError, path, parent } = context;
      // if (!parent.hasPOA) {
      if (!value) {
        return createError({
          message: 'Email Id is required',
          path,
        });
      }
      if (!emailRegex.test(value)) {
        return createError({
          message: 'Invalid Email Id',
          path,
        });
      }
      // }
      return true;
    }),

    mobile: yup.string().test('mobile', (value, context) => {
      const { createError, path, parent } = context;
      const codesList = getCountryCodes()
        .map((codes) => {
          if (codes.label === parent.countryNameAndCode) {
            return codes.countryCode;
          }
        })
        .filter((ele) => ele)
        .toString();
      // if (!parent.hasPOA) {
      if (
        !value &&
        ONBOARDING_INVESTOR[parent.applicationType] === ONBOARDING_INVESTOR.non_individual
      ) {
        return true;
      }
      if (!value) {
        return createError({
          message: 'Mobile number is required',
          path,
        });
      }
      if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
        return createError({
          message: 'Invalid Mobile number',
          path,
        });
      }
      if (!isValidPhoneNumber(value, codesList as CountryCode)) {
        return createError({
          message: 'Invalid Mobile number',
          path,
        });
      }
      if (applicantMobileNumbers.includes(value)) {
        return createError({
          message:
            'There is already an applicant associated with this Mobile number in this application',
          path,
        });
      }
      // }
      return true;
    }),
    countryNameAndCode: yup
      .string()
      .nullable()
      .test('countryNameAndCode', (value, context) => {
        const { createError, path, parent } = context;
        const codesList = getCountryCodes()
          .map((codes) => {
            if (codes.label === value) {
              return codes.countryCode;
            }
          })
          .filter((ele) => ele)
          .toString();
        // if (!parent.hasPOA) {
        if (
          !value &&
          ONBOARDING_INVESTOR[parent.applicationType] === ONBOARDING_INVESTOR.non_individual
        ) {
          return true;
        }
        if (!value) {
          return createError({
            message: 'Country Code is required',
            path,
          });
        }
        if (parent.mobile && !isValidPhoneNumber(parent.mobile, codesList as CountryCode)) {
          return createError({
            message: 'Invalid Mobile number',
            path,
          });
        }
        // }
        return true;
      }),
    dob: yup.string().test('dob', (value, context) => {
      const fieldValue = value === undefined ? '' : value;
      const { path, createError, parent } = context;
      if (IS_DOB_APPLICABLE_FOR_AMC) {
        if (!fieldValue) {
          return createError({
            message: 'Date of birth is required',
            path,
          });
        }
        if (futureAge(fieldValue || '') || fieldValue.toString().toLowerCase() === 'invalid date') {
          return createError({
            message: 'Invalid Date',
            path,
          });
        }
      }
      return true;
    }),
  });
  const initialValues1: IValues = {
    applicationType,
    investorCategory,
    investorSubCategory,
    nationality,
    countryNationality,
    salesRmId,
    placementAgent,
    firstName: '',
    lastName: '',
    middleName: '',
    countryNameAndCode: 'India: +91',
    countryCode: '+91',
    mobile: '',
    emailId: '',
    taxIdNumber: '',
    dob: '',
    // hasPOA: false,
    subdistributorId,
  };

  useEffect(() => {
    !location.state && history.push('investor-onboarding');
  }, []);

  // useEffect(() => {
  //   setDisablePOA(
  //     application
  //       ? application.hasPOA
  //         ? application.hasPOA
  //         : !application.hasPOA
  //       : !powerOfAttorney
  //   );
  // }, []);

  const amlFunc = async (payLoadValue: CreateApplicationRequestBody) => {
    const res = (!id
      ? await dispatch(createNewApplication(payLoadValue))
      : id && redirectTo
      ? await dispatch(addJointHolder(payLoadValue, id))
      : {}) as unknown as CreateApplicationResponceBody;
    if (res.creationStatus)
      return !id
        ? setOpenDialog({ open: true, message: res.message })
        : history.push(redirectTo, {
            id: application.id,
            applicant1ReferenceId: application?.applicant1ReferenceId,
          });
    if (!res.amlCheck && !res.creationStatus) {
      if (USER_ROLES.INVESTOR === role) {
        return setAmlFailedResInvestor(true);
      }
      setAmlFailedresponse(res?.message || '');
      return setAmlPopup({ res });
    }
  };

  const handleSubmit1 = async (values: IValues) => {
    try {
      setAmlAcknowledgementLoading(true);
      const {
        dob,
        applicationType,
        countryNameAndCode,
        mobile: mobileNumber,
        emailId,
        firstName,
        lastName,
        middleName,
        // hasPOA,
      } = values;
      const payLoadValue = {
        applicationType,
        countryCode: countryNameAndCode?.split(':')[1].trim(),
        countryNameAndCode,
        mobileNumber,
        emailId,
        firstName,
        lastName,
        middleName,
        investorCategory,
        investorSubCategory,
        nationality,
        countryNationality,
        salesRmId: salesRmId ? Number(salesRmId) : null,
        placementAgent,
        dob,
        // hasPOA,
        subdistributorId: subdistributorId ? Number(subdistributorId) : null,
      };
      await amlFunc(payLoadValue);
      return;
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setAmlAcknowledgementLoading(false);
    }
  };
  const handleClose = () => {
    setAmlPopup(null);
  };
  const onSubmit = async (values: AmlPopupValues) => {
    try {
      setAmlAcknowledgementLoading(true);
      const { amlComments, fileId, amlAcknowledgement } = values;
      const { status, message, amlCheck, amlData, creationStatus, ...rest } = amlPopup?.res || {};
      setAmlPopup(null);
      const payLoadValue = {
        ...rest,
        amlComments,
        complianceFileId: fileId || '',
        amlAcknowledgement,
      };
      await amlFunc(payLoadValue as CreateApplicationRequestBody);
      return;
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setAmlAcknowledgementLoading(false);
    }
  };
  return (
    <>
      <Formik
        initialValues={initialValues1}
        validationSchema={validationSchema1}
        onSubmit={handleSubmit1}>
        {({ handleSubmit, values }) => (
          <>
            <Box component="form" noValidate onSubmit={handleSubmit}>
              <MFTextField
                name="firstName"
                label="First Name"
                placeholder="Enter First Name"
                autoFocus
              />
              <MFTextField name="middleName" label="Middle Name" placeholder="Enter Middle name" />
              <MFTextField name="lastName" label="Last Name" placeholder="Enter Last Name" />
              {/* <MFCheckbox
                name="hasPOA"
                label="Power of Attorney"
                color="primary"
                sx={{
                  '.MuiTypography-root': {
                    color: 'primary.main',
                    fontWeight: 500,
                    fontSize: 14,
                    letterSpacing: '0.9625px',
                  },
                }}
                disabled={disablePOA || false}
              />
              {!values.hasPOA && (
                <> */}
              <MFTextField name="emailId" label="Email" placeholder="Enter Email" />
              <MobileNumberField
                name="mobile"
                countryCodeFieldName="countryNameAndCode"
                countryCodeValue={values.countryNameAndCode}
                label="Contact"
                placeholder="Enter Contact"
              />
              {/* </>
              )} */}
              {IS_DOB_APPLICABLE_FOR_AMC && (
                <TextDatePicker
                  label={'Date of Birth/Incorporation'}
                  inputLabelStyles={{
                    transform: 'unset',
                    fontSize: 14,
                    fontWeight: 500,
                    color: 'rgba(0,0,0,0.7)',
                  }}
                  placeholder={'Enter Date of Birth'}
                  name={`dob`}
                />
              )}
              <SuccessDialog
                message={openDialog.message}
                onClose={() => {
                  setOpenDialog({
                    open: false,
                    message: '',
                  });
                }}
                open={openDialog.open}
                setOpen={() => {
                  setOpenDialog({
                    open: false,
                    message: '',
                  });
                  history.push('/application');
                }}
              />
              <AmlPopup
                handleClose={handleClose}
                amlPopupOpen={amlPopup !== null}
                onSubmit={onSubmit}
                amlFailedresponse={amlFailedresponse}
                // FURTHER_INFORMATION={amlFailedresponse?.FURTHER_INFORMATION}
                // EXTERNAL_SOURCES={amlFailedresponse?.EXTERNAL_SOURCES}
                displayDocInfo={true}
              />
              <InvestorAMLFailDialog
                content="AML Check Failed. please reach out to RM to add investor"
                actions={[
                  {
                    label: 'Go back to Application',
                    onClick: () => {
                      setAmlFailedResInvestor(false);
                      history.push(redirectTo, {
                        id: application?.id,
                        applicant1ReferenceId: application?.applicant1ReferenceId,
                      });
                    },
                  },
                ]}
                open={amlFailedresInvestor}
              />
              <MFSubmitButton label="Proceed" loadingEnable={amlAcknowledgementLoading} />
            </Box>
          </>
        )}
      </Formik>
    </>
  );
}
